import {Feature, Features} from "../feature";

export const chain1Filter = {
    filterInPlace: (features: Feature[]) => {
        const chain1Features = features.filter(f => f.name.includes(Features.chain) && f.atoms.length === 1)

        // A chain.1 feature is unneeded if another feature completely contains the atoms and connections
        // of the chain.1 feature.
        // The connections of the chain.1 need to merged into the connections of the containing feature.
        chain1Features.forEach(c1f => {
            const containingFeatures = features.filter(f => f !== c1f && c1f.atoms.every(a => f.atoms.includes(a)))
            containingFeatures.forEach(containingFeature => {
                const connectionAtoms = new Set([...containingFeature.connections, ...c1f.connections]);
                containingFeature.connections = Array.from(connectionAtoms).filter(a => !containingFeature.atoms.includes(a));
            })

            // Now that the chain feature has been accounted for, we can whack it.
            if(containingFeatures.length > 0) {
                features.splice(features.indexOf(c1f), 1);
            }
        })
    }
}